import { z } from 'zod';
import { isValidCPF } from '@/utils/form-validators';
import { isValidEmail } from '@/utils/form-validators/email';

export const formValidationSchema = z
  .object({
    name: z
      .string()
      .min(5, 'O nome deve ter pelo menos 5 caracteres.')
      .max(255, 'O nome não pode ter mais de 255 caracteres.'),
    email: z.string().optional(),
    cpf: z.string().optional(),
    internal_employee_id: z.string().optional(),
    type_collaborator: z.string().optional(),
    position_company: z.string().optional(),
    department: z.string().optional(),
    team: z.string().optional(),
    manager_email: z.string().optional(),
    building: z.string().optional(),
    region: z.string().optional(),
    state: z.string().optional(),
    city: z.string().optional(),
    company: z.string().optional(),
    cost_center: z.string().optional(),
    is_admin: z.boolean().optional(),
    type_registration: z.enum(['email', 'cpf']).optional(),
  })
  .superRefine((data, ctx) => {
    const hasEmail = !!data.email;
    const hasCpf = !!data.cpf;
    const message =
      'É necessário informar um e-mail ou cpf para cadastrar um novo usuário';
    if (!hasEmail && !hasCpf) {
      ctx.addIssue({
        path: ['email'],
        code: 'custom',
        message,
      });
      ctx.addIssue({
        path: ['cpf'],
        code: 'custom',
        message,
      });
      return;
    }

    if (hasEmail && !isValidEmail(data.email!)) {
      ctx.addIssue({
        path: ['email'],
        code: 'custom',
        message: 'Informe um email válido!',
      });
    }

    if (hasCpf) {
      if (!isValidCPF(data.cpf!)) {
        ctx.addIssue({
          path: ['cpf'],
          code: 'custom',
          message: 'Informe um CPF válido',
        });
      } else if (data.cpf!.length > 14) {
        ctx.addIssue({
          path: ['cpf'],
          code: 'custom',
          message: 'CPF não pode ter mais de 14 caracteres',
        });
      }
    }
  });

export type RegisterEmployerFormData = z.infer<typeof formValidationSchema>;
